import { createFileRoute, useParams } from '@tanstack/react-router';

import {
  Apex,
  FieldForceManagement,
  Greenland,
  MultisensoryExperience,
  NetworkPlanning,
  PcRoadmap,
  PorscheImportAgreements,
  PorscheStrategy2030,
  RealEstate,
  RedirectToTab,
  RetailDesign,
  Survey,
} from './-components';

const appToComponent = {
  'field-force-management': FieldForceManagement,
  greenland: Greenland,
  'porsche-strategy-2030': PorscheStrategy2030,
  'network-planning': NetworkPlanning,
  'retail-design': RetailDesign,
  survey: Survey,
  'multisensory-experience': MultisensoryExperience,
  'pc-roadmap': PcRoadmap,
  apex: Apex,
  'porsche-import-agreements': PorscheImportAgreements,
  'real-estate': RealEstate,
};

export const Route = createFileRoute('/admin/person-info/$personId/$app')({
  component: () => {
    const { app } = useParams({ from: '/admin/person-info/$personId/$app' });

    if (app in appToComponent) {
      const Component = appToComponent[app as keyof typeof appToComponent];
      return <Component />;
    }

    return <RedirectToTab />;
  },
});
